// import lazyLoading from '../lazyLoading';

export default {
  name: 'technical',
  caption: 'Technical',
  wdm16_id: '',
  icon: 'icon-settings',
  path: '/technical',
  // component: lazyLoading('patient/index'),
  required: [],
  permissions: [],
  meta: {
    required: [],
    icon: 'fa-bars',
    expanded: false
  }
};
